import { combineReducers } from "redux";
import {
  MSTTRAYEK_GET_LOADING,
  MSTTRAYEK_GET_ERROR,
  MSTTRAYEK_GET_SUCCESS,
  MSTTRAYEK_VIEW_ERROR,
  MSTTRAYEK_VIEW_LOADING,
  MSTTRAYEK_VIEW_SUCCESS,
  MSTTRAYEK_ADD_ERROR,
  MSTTRAYEK_ADD_LOADING,
  MSTTRAYEK_ADD_SUCCESS,
  MSTTRAYEK_DELETE_ERROR,
  MSTTRAYEK_DELETE_LOADING,
  MSTTRAYEK_DELETE_SUCCESS,
  MSTTRAYEK_LIST_ERROR,
  MSTTRAYEK_LIST_LOADING,
  MSTTRAYEK_LIST_SUCCESS,
  TRAYEK_MANAGEMENT_QUOTA_LIST_ERROR,
  TRAYEK_MANAGEMENT_QUOTA_LIST_SUCCESS,
  TRAYEK_MANAGEMENT_QUOTA_LIST_LOADING,
  SCHEDULE_MANAGEMENT_QUOTA_ERROR,
  SCHEDULE_MANAGEMENT_QUOTA_LOADING,
  SCHEDULE_MANAGEMENT_QUOTA_SUCCESS,
  GET_MANAGEMENT_QUOTA_ERROR,
  GET_MANAGEMENT_QUOTA_LOADING,
  GET_MANAGEMENT_QUOTA_SUCCESS,
  UPDATE_MANAGEMENT_QUOTA_ERROR,
  UPDATE_MANAGEMENT_QUOTA_LOADING,
  UPDATE_MANAGEMENT_QUOTA_SUCCESS,
  ADD_SHIPPER_ON_TRAYEK_ERROR,
  ADD_SHIPPER_ON_TRAYEK_LOADING,
  ADD_SHIPPER_ON_TRAYEK_SUCCESS,
  REMOVE_SHIPPER_ON_TRAYEK_ERROR,
  REMOVE_SHIPPER_ON_TRAYEK_LOADING,
  REMOVE_SHIPPER_ON_TRAYEK_SUCCESS,
  LIST_SHIPPER_ON_TRAYEK_ERROR,
  LIST_SHIPPER_ON_TRAYEK_LOADING,
  LIST_SHIPPER_ON_TRAYEK_SUCCESS,
  MSTTRAYEK_TERPUSAT_GET_ERROR,
  MSTTRAYEK_TERPUSAT_GET_LOADING,
  MSTTRAYEK_TERPUSAT_GET_SUCCESS,
} from "../actions/constant";

const msttrayekAddShipperError = (state = false, action) => {
  switch (action.type) {
    case ADD_SHIPPER_ON_TRAYEK_ERROR:
      return action.msttrayekAddShipperError;
    default:
      return state;
  }
};

const msttrayekAddShipperLoading = (state = false, action) => {
  switch (action.type) {
    case ADD_SHIPPER_ON_TRAYEK_LOADING:
      return action.msttrayekAddShipperLoading;
    default:
      return state;
  }
};

const msttrayekAddShipperSuccess = (state = false, action) => {
  switch (action.type) {
    case ADD_SHIPPER_ON_TRAYEK_SUCCESS:
      return action.msttrayekAddShipperSuccess;
    default:
      return state;
  }
};

const msttrayekAddShipper = (state = [], action) => {
  switch (action.type) {
    case ADD_SHIPPER_ON_TRAYEK_SUCCESS:
      return action.msttrayekAddShipper;
    default:
      return state;
  }
};

const msttrayekRemoveShipperError = (state = false, action) => {
  switch (action.type) {
    case REMOVE_SHIPPER_ON_TRAYEK_ERROR:
      return action.msttrayekRemoveShipperError;
    default:
      return state;
  }
};

const msttrayekRemoveShipperLoading = (state = false, action) => {
  switch (action.type) {
    case REMOVE_SHIPPER_ON_TRAYEK_LOADING:
      return action.msttrayekRemoveShipperLoading;
    default:
      return state;
  }
};

const msttrayekRemoveShipperSuccess = (state = false, action) => {
  switch (action.type) {
    case REMOVE_SHIPPER_ON_TRAYEK_SUCCESS:
      return action.msttrayekRemoveShipperSuccess;
    default:
      return state;
  }
};

const msttrayekRemoveShipper = (state = [], action) => {
  switch (action.type) {
    case REMOVE_SHIPPER_ON_TRAYEK_SUCCESS:
      return action.msttrayekRemoveShipper;
    default:
      return state;
  }
};

const msttrayekListShipperError = (state = false, action) => {
  switch (action.type) {
    case LIST_SHIPPER_ON_TRAYEK_ERROR:
      return action.msttrayekListShipperError;
    default:
      return state;
  }
};

const msttrayekListShipperLoading = (state = false, action) => {
  switch (action.type) {
    case LIST_SHIPPER_ON_TRAYEK_LOADING:
      return action.msttrayekListShipperLoading;
    default:
      return state;
  }
};

const msttrayekListShipperSuccess = (state = false, action) => {
  switch (action.type) {
    case LIST_SHIPPER_ON_TRAYEK_SUCCESS:
      return action.msttrayekListShipperSuccess;
    default:
      return state;
  }
};

const msttrayekListShipper = (state = [], action) => {
  switch (action.type) {
    case LIST_SHIPPER_ON_TRAYEK_SUCCESS:
      return action.msttrayekListShipper;
    default:
      return state;
  }
};

const trayekManagementQuotaError = (state = false, action) => {
  switch (action.type) {
    case TRAYEK_MANAGEMENT_QUOTA_LIST_ERROR:
      return action.trayekManagementQuotaError;
    default:
      return state;
  }
};

const trayekManagementQuotaLoading = (state = false, action) => {
  switch (action.type) {
    case TRAYEK_MANAGEMENT_QUOTA_LIST_LOADING:
      return action.trayekManagementQuotaLoading;
    default:
      return state;
  }
};

const trayekManagementQuotaSuccess = (state = false, action) => {
  switch (action.type) {
    case TRAYEK_MANAGEMENT_QUOTA_LIST_SUCCESS:
      return action.trayekManagementQuotaSuccess;
    default:
      return state;
  }
};

const trayekManagementQuota = (state = [], action) => {
  switch (action.type) {
    case TRAYEK_MANAGEMENT_QUOTA_LIST_SUCCESS:
      return action.trayekManagementQuota;
    default:
      return state;
  }
};

const scheduleManagementQuotaError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_MANAGEMENT_QUOTA_ERROR:
      return action.scheduleManagementQuotaError;
    default:
      return state;
  }
};

const scheduleManagementQuotaLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_MANAGEMENT_QUOTA_LOADING:
      return action.scheduleManagementQuotaLoading;
    default:
      return state;
  }
};

const scheduleManagementQuotaSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_MANAGEMENT_QUOTA_SUCCESS:
      return action.scheduleManagementQuotaSuccess;
    default:
      return state;
  }
};

const scheduleManagementQuota = (state = [], action) => {
  switch (action.type) {
    case SCHEDULE_MANAGEMENT_QUOTA_SUCCESS:
      return action.scheduleManagementQuota;
    default:
      return state;
  }
};

const getManagementQuotaError = (state = false, action) => {
  switch (action.type) {
    case GET_MANAGEMENT_QUOTA_ERROR:
      return action.getManagementQuotaError;
    default:
      return state;
  }
};

const getManagementQuotaLoading = (state = false, action) => {
  switch (action.type) {
    case GET_MANAGEMENT_QUOTA_LOADING:
      return action.getManagementQuotaLoading;
    default:
      return state;
  }
};

const getManagementQuotaSuccess = (state = false, action) => {
  switch (action.type) {
    case GET_MANAGEMENT_QUOTA_SUCCESS:
      return action.getManagementQuotaSuccess;
    default:
      return state;
  }
};

const getManagementQuota = (state = [], action) => {
  switch (action.type) {
    case GET_MANAGEMENT_QUOTA_SUCCESS:
      return action.getManagementQuota;
    default:
      return state;
  }
};

const updateManagementQuotaError = (state = false, action) => {
  switch (action.type) {
    case UPDATE_MANAGEMENT_QUOTA_ERROR:
      return action.updateManagementQuotaError;
    default:
      return state;
  }
};

const updateManagementQuotaLoading = (state = false, action) => {
  switch (action.type) {
    case UPDATE_MANAGEMENT_QUOTA_LOADING:
      return action.updateManagementQuotaLoading;
    default:
      return state;
  }
};

const updateManagementQuotaSuccess = (state = false, action) => {
  switch (action.type) {
    case UPDATE_MANAGEMENT_QUOTA_SUCCESS:
      return action.updateManagementQuotaSuccess;
    default:
      return state;
  }
};

const updateManagementQuota = (state = [], action) => {
  switch (action.type) {
    case UPDATE_MANAGEMENT_QUOTA_SUCCESS:
      return action.updateManagementQuota;
    default:
      return state;
  }
};

const msttrayekGetError = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_GET_ERROR:
      return action.msttrayekGetError;
    default:
      return state;
  }
};

const msttrayekGetLoading = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_GET_LOADING:
      return action.msttrayekGetLoading;
    default:
      return state;
  }
};

const msttrayekGetSuccess = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_GET_SUCCESS:
      return action.msttrayekGetSuccess;
    default:
      return state;
  }
};

const msttrayeks = (state = [], action) => {
  switch (action.type) {
    case MSTTRAYEK_GET_SUCCESS:
      return action.msttrayeks;
    default:
      return state;
  }
};

const msttrayekTerpusatGetError = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_TERPUSAT_GET_ERROR:
      return action.msttrayekGetError;
    default:
      return state;
  }
};

const msttrayekTerpusatGetLoading = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_TERPUSAT_GET_LOADING:
      return action.msttrayekGetLoading;
    default:
      return state;
  }
};

const msttrayekTerpusatGetSuccess = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_TERPUSAT_GET_SUCCESS:
      return action.msttrayekGetSuccess;
    default:
      return state;
  }
};

const msttrayekTerpusats = (state = [], action) => {
  switch (action.type) {
    case MSTTRAYEK_TERPUSAT_GET_SUCCESS:
      return action.msttrayekTerpusats;
    default:
      return state;
  }
};

const msttrayekListError = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_LIST_ERROR:
      return action.msttrayekListError;
    default:
      return state;
  }
};

const msttrayekListLoading = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_LIST_LOADING:
      return action.msttrayekListLoading;
    default:
      return state;
  }
};

const msttrayekListSuccess = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_LIST_SUCCESS:
      return action.msttrayekListSuccess;
    default:
      return state;
  }
};

const listtrayeks = (state = [], action) => {
  switch (action.type) {
    case MSTTRAYEK_LIST_SUCCESS:
      return action.listtrayeks;
    default:
      return state;
  }
};

const msttrayekViewLoading = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_VIEW_LOADING:
      return action.msttrayekViewLoading;
    default:
      return state;
  }
};

const msttrayekViewError = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_VIEW_ERROR:
      return action.msttrayekViewError;
    default:
      return state;
  }
};

const msttrayekViewSuccess = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_VIEW_SUCCESS:
      return action.msttrayekViewSuccess;
    default:
      return state;
  }
};

const msttrayek = (state = [], action) => {
  switch (action.type) {
    case MSTTRAYEK_VIEW_SUCCESS:
      return action.msttrayek;
    default:
      return state;
  }
};

const msttrayekAdded = (state = [], action) => {
  switch (action.type) {
    case MSTTRAYEK_ADD_SUCCESS:
      return action.msttrayek;
    default:
      return state;
  }
};

const msttrayekAddError = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_ADD_ERROR:
      return action.msttrayekAddError;
    default:
      return state;
  }
};

const msttrayekAddLoading = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_ADD_LOADING:
      return action.msttrayekAddLoading;
    default:
      return state;
  }
};

const msttrayekAddSuccess = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_ADD_SUCCESS:
      return action.msttrayekAddSuccess;
    default:
      return state;
  }
};

const msttrayekDeleteError = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_DELETE_ERROR:
      return action.msttrayekDeleteError;
    default:
      return state;
  }
};

const msttrayekDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_DELETE_LOADING:
      return action.msttrayekDeleteLoading;
    default:
      return state;
  }
};

const msttrayekDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case MSTTRAYEK_DELETE_SUCCESS:
      return action.msttrayekDeleteSuccess;
    default:
      return state;
  }
};

const msttrayekReducer = combineReducers({
  msttrayekListError,
  msttrayekListLoading,
  msttrayekListSuccess,
  listtrayeks,

  msttrayekGetError,
  msttrayekGetLoading,
  msttrayekGetSuccess,
  msttrayeks,

  msttrayekViewLoading,
  msttrayekViewError,
  msttrayekViewSuccess,
  msttrayek,

  msttrayekAddError,
  msttrayekAddLoading,
  msttrayekAddSuccess,
  msttrayekAdded,

  msttrayekDeleteError,
  msttrayekDeleteLoading,
  msttrayekDeleteSuccess,

  trayekManagementQuotaError,
  trayekManagementQuotaLoading,
  trayekManagementQuotaSuccess,
  trayekManagementQuota,

  scheduleManagementQuotaError,
  scheduleManagementQuotaLoading,
  scheduleManagementQuotaSuccess,
  scheduleManagementQuota,

  getManagementQuotaError,
  getManagementQuotaLoading,
  getManagementQuotaSuccess,
  getManagementQuota,

  updateManagementQuotaError,
  updateManagementQuotaLoading,
  updateManagementQuotaSuccess,
  updateManagementQuota,

  msttrayekAddShipperError,
  msttrayekAddShipperSuccess,
  msttrayekAddShipperLoading,
  msttrayekAddShipper,

  msttrayekRemoveShipperError,
  msttrayekRemoveShipperSuccess,
  msttrayekRemoveShipperLoading,
  msttrayekRemoveShipper,

  msttrayekListShipperError,
  msttrayekListShipperSuccess,
  msttrayekListShipperLoading,
  msttrayekListShipper,

  msttrayekTerpusatGetError,
  msttrayekTerpusatGetLoading,
  msttrayekTerpusatGetSuccess,
  msttrayekTerpusats,
});

export default msttrayekReducer;
